import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import style from './CanvasDraw.module.css';
import classNames from 'classnames/bind';
import ReactPlayer from 'react-player';
import { Alert, Toast } from '../../../../../../components';
import { getLine } from '../../../../../../utils';
import { RefreshIcon, RestoreIcon, SquareIcon } from '../../../../../../components/Icons/Icons';
import { useTranslation } from 'react-i18next';
// import { SettingAIContext } from '../../../../../contexts';
const cx = classNames.bind(style);

function CanvasDraw({ polygon, onChange, path, width, height, cropRegion, setCropRegion, defaultShape, setDefaultShape, reFresh }) {
    const canvasRef = useRef(null);
    const [canvas, setCanvas] = useState(null);
    const [draw, setDraw] = useState(false);
    const [restore, setReStore] = useState(false);
    const [defaultRoi, setDefaultRoi] = useState(true);
    const [changed, setChanged] = useState(false);
    const { t } = useTranslation();
    useEffect(() => {
        if (cropRegion > 0) {
            let cropX = width * cropRegion;
            let cropY = height * cropRegion;
            setDefaultShape([
                { x1: 0 + cropX, y1: 0 + cropY, x2: 0 + cropX, y2: 0 + cropY, x1Control: 0 + cropX, y1Control: 0 + cropY, x2Control: 0 + cropX, y2Control: 0 + cropY },
                { x1: 0 + cropX, y1: 0 + cropY, x2: width - cropX, y2: 0 + cropY, x1Control: 0 + cropX, y1Control: 0 + cropY, x2Control: width - cropX, y2Control: 0 + cropY },
                { x1: width - cropX, y1: 0 + cropY, x2: width - cropX, y2: height - cropY, x1Control: width - cropX, y1Control: 0 + cropY, x2Control: width - cropX, y2Control: height - cropY },
                { x1: width - cropX, y1: height - cropY, x2: 0 + cropX, y2: height - cropY, x1Control: width - cropX, y1Control: height - cropY, x2Control: 0 + cropX, y2Control: height - cropY },
                { x1: 0 + cropX, y1: height - cropY, x2: 0 + cropX, y2: 0 + cropY, x1Control: 0 + cropX, y1Control: height - cropY, x2Control: 0 + cropX, y2Control: 0 + cropY },
            ])
        } else {
            setDefaultShape([]);
        }
    }, [cropRegion])
    useEffect(() => {
        setCanvas(canvasRef.current);
        const ctx = canvasRef.current.getContext("2d");
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    }, [canvasRef])

    const drawPolygon = (ctx, lines) => {
        let xa, ya, xb, yb, x3, y3, x4, y4;
        lines.forEach((item, index) => {
            if (index === 0) {
                xa = item.x1Control;
                ya = item.y1Control;
            } else if (index === 2) {
                xb = item.x1Control;
                yb = item.y1Control;
            } else if (index === 3) {
                x3 = item.x1Control;
                y3 = item.y1Control;
            } else if (index === 4) {
                x4 = item.x1Control;
                y4 = item.y1Control;
            }
        });
        // Bắt đầu vẽ hình tứ giác
        ctx.beginPath();
        ctx.moveTo(xa, ya);
        ctx.lineTo(xb, yb);
        ctx.lineTo(x3, y3);
        ctx.lineTo(x4, y4);
        ctx.closePath();
        // Thiết lập màu và tô màu nền cho hình tứ giác
        ctx.fillStyle = 'rgba(0, 64, 255, 0.04)';
        ctx.fill();
    };

    const drawLine = (ctx, x1, y1, x2, y2, x1Control, y1Control, x2Control, y2Control, color) => {
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.strokeStyle = color;
        ctx.lineWidth = 2;
        // Vẽ điểm control
        const circle = new Path2D();
        circle.arc(x1Control, y1Control, 5, 0, 2 * Math.PI);
        circle.arc(x2Control, y2Control, 5, 0, 2 * Math.PI);
        ctx.fill(circle);
        ctx.fillStyle = color
    };

    const autoDraw = (lines) => {
        if (canvas) {
            const ctx = canvas.getContext("2d");
            for (let index = 0; index < 3; index++) {
                if (lines.length <= 5 && lines.length > 0) {
                    lines.forEach(({ x1, y1, x2, y2, x1Control, y1Control, x2Control, y2Control }) => {
                        drawLine(ctx, x1, y1, x2, y2, x1Control, y1Control, x2Control, y2Control, "white");
                    });
                    // Vẽ hình tứ giác khi đủ số lượng line
                    if (lines.length === 5) {
                        drawPolygon(ctx, lines);
                    }
                }
            }
        }
    }

    const drawDefaultPolygon = (lines) => {
        if (canvas) {
            const ctx = canvas.getContext("2d");
            for (let index = 0; index < 3; index++) {
                if (lines?.length <= 5 && lines?.length > 0) {
                    lines.forEach(({ x1, y1, x2, y2, x1Control, y1Control, x2Control, y2Control }) => {
                        drawLine(ctx, x1, y1, x2, y2, x1Control, y1Control, x2Control, y2Control, "red");
                    });
                }
            }
        }
    }

    // console.log(polygon.polygon1);

    useEffect(() => {
        if (defaultRoi) {
            autoDraw(polygon.polygon1);
            autoDraw(polygon.polygon2);
            autoDraw(polygon.polygon3);
        }
    }, [polygon, defaultRoi])

    useEffect(() => {
        if (canvas) {
            if (cropRegion !== 0 && defaultShape) {
                const ctx = canvas.getContext("2d");
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                drawDefaultPolygon(defaultShape);
                // if (!changed) {
                autoDraw(polygon.polygon1);
                autoDraw(polygon.polygon2);
                autoDraw(polygon.polygon3);
                // }
            }
            else {
                const ctx = canvas.getContext("2d");
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                // drawDefaultPolygon(defaultShape);
                autoDraw(polygon.polygon1);
                autoDraw(polygon.polygon2);
                autoDraw(polygon.polygon3);
            }
        }
    }, [canvas, cropRegion, defaultShape, changed, polygon])

    const handleCanvasClick = (event) => {
        if (draw) {
            const { offsetX: x, offsetY: y } = event.nativeEvent;
            let { polygon1, polygon2, polygon3 } = polygon;
            if (polygon1.length < 6 && polygon1.length !== 5) {
                const line1 = getLine(x, y, polygon1)
                let poly1 = [...polygon.polygon1, ...line1];
                autoDraw(poly1);
                onChange({ ...polygon, polygon1: [...polygon1, ...line1] })
            }
            setChanged(true)
        }
    }

    const handleDraw = () => {
        setDraw(!draw);
        setDefaultRoi(false);
    }

    useMemo(() => {
        if (restore && canvas) {
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, 1000, 1000);
            setReStore(false);
            autoDraw(polygon.polygon1);
            autoDraw(polygon.polygon2);
            autoDraw(polygon.polygon3);
            drawDefaultPolygon(defaultShape);
        }
        if (polygon?.polygon1?.length === 0 && cropRegion === 0 && canvas) {
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, 1000, 1000);
        }
    }, [polygon, restore, canvas])

    const handleRestore = () => {
        let { polygon1, polygon2, polygon3 } = polygon;
        if (polygon3.length > 0) {
            onChange({
                ...polygon, polygon3: []
            })
        } else if (polygon2.length > 0) {
            onChange({
                ...polygon, polygon2: []
            })
        } else if (polygon1.length > 0) {
            onChange({
                ...polygon, polygon1: []
            })
        }
        setReStore(true);
    }

    const onChangeRegion = (e) => {
        let value = e.target.value;
        if (value === 0) {
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
        if (value > 0.5 || value < 0) {
            Toast.open("Gía trị bỏ nền từ 0 - 0.5", "danger");
        } else {
            setCropRegion(value)
        }
    }

    useLayoutEffect(() => {
        if (canvas) {
            // Fix size off canvas if screen hight quality
            const dpr = window.devicePixelRatio;
            const rect = canvas.getBoundingClientRect();
            canvas.width = rect.width * dpr;
            canvas.height = rect.height * dpr;
            const ctx = canvas.getContext("2d");
            ctx.scale(dpr, dpr);
            canvas.style.width = `${rect.width}px`;
            canvas.style.height = `${rect.height}px`;
            // Clear when remount or remove canvas
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
    }, [canvas]);


    return (
        <>
            <div className={cx('list-config')}>
                <div className={cx('list-config-name')}>{t("setting.Regional_configuration")}</div>
                <div className={cx('draw-container')}>
                    <div className={cx('box-video')} style={{ width: `${width}px` }}>
                        {path ? (
                            <ReactPlayer
                                url={`${process.env.REACT_APP_BASE_URL}livestream${path}`}
                                width={'100%'}
                                height={`${height + 1}px`}
                                muted
                                playing
                                className={cx('react-player')}
                            />
                        ) : (
                            <div style={{ width: '100%', height: `${height + 1}px` }}>
                                <p className={cx('no-image')}>{t('location.cameraIsOff')}</p>
                            </div>
                        )}
                        <canvas
                            ref={canvasRef}
                            className={cx('canvas-space')}
                            style={{
                                width: '100%',
                                height: `${height}px`,
                            }}
                            onMouseDown={handleCanvasClick}
                        />
                    </div>
                </div>
                <div className={cx('controller-draw')}>
                    <div className={cx('left-button')}>
                        <button className={cx('button-control')} onClick={reFresh}>
                            {t('setting.Refresh_image')}
                            <RefreshIcon />
                        </button>
                        <button className={cx('button-control', draw && 'active')} onClick={handleDraw}>
                            {t('setting.Drawing')}
                            <SquareIcon />
                        </button>
                        <div className={cx('crop_region')}>
                            <p>{t('setting.Remove_background')}:</p>
                            <input
                                type='number'
                                max={0.5}
                                min={0}
                                step={0.1}
                                className={cx("input_crop_region")}
                                onChange={(e) => {
                                    onChangeRegion(e);
                                    setChanged(true)
                                }}
                                value={cropRegion}
                            />
                        </div>
                    </div>
                    <div className={cx('right-button')}>
                        <button className={cx('button-control')} onClick={handleRestore}>
                            <RestoreIcon />
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CanvasDraw;